import { Select } from "antd";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface IProps {
  schoolGbn: string;
  setSchoolGbn: (schoolGbn: string) => void;
};

const SchoolTypeSelect: FC<IProps> = ({
  schoolGbn,
  setSchoolGbn,
}) => {
  const { t } = useTranslation();

  const options = [
    { label: t('common.text.all'), value: '' },
    { label: t('system.school.option1'), value: 'ES' },
    { label: t('system.school.option2'), value: 'MS' },
    { label: t('system.school.option3'), value: 'HS' },
  ];
  
  return (
    <Select
      value={schoolGbn}
      onChange={setSchoolGbn}
    >
      {options?.map((option, index) => (
        <Select.Option
          key={index}
          value={option.value}
        >
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SchoolTypeSelect;